export var HttpVerb;
(function (HttpVerb) {
    HttpVerb[HttpVerb["GET"] = 0] = "GET";
    HttpVerb[HttpVerb["POST_JSON"] = 1] = "POST_JSON";
    HttpVerb[HttpVerb["POST_FORM"] = 2] = "POST_FORM";
    HttpVerb[HttpVerb["DELETE"] = 3] = "DELETE";
    HttpVerb[HttpVerb["PUT"] = 4] = "PUT";
    HttpVerb[HttpVerb["PATCH"] = 5] = "PATCH";
})(HttpVerb || (HttpVerb = {}));
//# sourceMappingURL=http-verb.enum.js.map